// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/css/vendor/angular-toggle-switch.css
// module id = h84R
// module chunks = 1